<template>
    <div class="create-users">
        <div
                class="return-button"
                @click="returnButton"
        >

            <!--            {{ `${isEditMode ? this.localUser.email : 'New User'}` }}-->
        </div>
        <div
                class="page-sub-menu"
        >
            <VInput
                    v-model="localUser.email"
                    :class="{invalid:!validation.email}"
                    :disabled="isEditMode"
                    class="input"
                    placeholder="Email for invitation"
            />
            <VInput
                    v-model="localUser.profilename"
                    :class="{invalid:!validation.name}"
                    class="input"
                    placeholder="Name for invitation"
            />
        </div>
        <div class="page__dates">
            <div class="date">
                <div class="date__label">
                    Start Date
                </div>
                <VDateTimePicker
                        :dates="{start:dates.start,
                        end:null}"
                        :is-show-presets="false"
                        :range="false"
                        :solo="true"
                        :format="'YYYY-MM-DD'"
                        :disabled-date="disabledStartDate"
                        @changeSolo="changeDate($event,'start')"
                />
            </div>
            <div class="date">
                <div class="date__label">
                    End Date
                </div>
                <VDateTimePicker
                        :dates="{start:dates.end,
                        end:null}"
                        :is-show-presets="false"
                        :range="false"
                        :solo="true"
                        :format="'YYYY-MM-DD'"
                        :disabled-date="disabledEndDate"
                        @changeSolo="changeDate($event,'end')"
                />
            </div>
            <div
                    class="function-text"
                    v-if="localUser.filters.func && localUser.filters.func.length"
            >
                Func :
                <VLabel
                        v-for="(funcName,funcIndex) in localUser.filters.func"
                        :color="'#6089E7'"
                        :key="funcIndex"
                        action="simple"
                        @click="funcRemove(funcIndex)"
                >{{ funcName }}
                </VLabel>
            </div>
        </div>
        <div class="content">
            <div class="content__column column">
                <div
                        class="column__item column__item_apps"
                        :class="{invalid:!validation.apps}"
                >
                    <div class="column__item__header">
                        <div class="title">
                            Apps
                        </div>
                        <div class="header-controls">
                            <div class="VSearch">
                                <span class="VSearch-icon"></span>
                                <VInput
                                        v-model.trim="appSearchTerm"
                                        placeholder="Search..."
                                />
                            </div>
                            <div class="button">
                                <div class="label">
                                    Select All
                                </div>
                                <div @click="selectAllapps(!localUser.apps.isSelectedAll)">
                                    <VCheckbox
                                            :checked="localUser.apps.isSelectedAll"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tip-message">
                        Add at least 1 application
                    </div>
                    <div class="column__item__body">
                        <div
                                v-for="(item, itemIndex) in filteredApps"
                                :key="itemIndex"
                                :style="{backgroundImage: `url('${item.logo_small}')`}"
                                :class="{active: item.isActive}"
                                class="unit"
                                @click="chooseApplication(item)"
                                @mouseover="showTooltip($event,'appTooltip',item)"
                        ></div>
                    </div>
                </div>
                <div
                        class="column__item column__item_events"
                        :class="{invalid:!validation.events}"
                >
                    <div class="column__item__header">
                        <div class="title">
                            events
                        </div>
                        <div class="button">
                            <div class="label">
                                Select All
                            </div>
                            <div @click="selectAllEvents(!localUser.events.isSelectedAll)">
                                <VCheckbox
                                        :checked="localUser.events.isSelectedAll"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="tip-message">
                        Add at least 1 event
                    </div>
                    <div class="column__item__body">
                        <div class="column__item__body-row">
                            <VLabel
                                    v-for="(event, eventIndex) in localUser.events.items"
                                    :key="eventIndex"
                                    :color="event.color"
                                    :action="event.isActive ? 'remove' : 'add'"
                                    @click="chooseEvent(event)"
                            >
                                {{ event.name }}
                            </VLabel>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content__column column">
                <div
                        class="column__item column__item_features"
                        :class="{invalid:!validation.features}"
                >
                    <div class="column__item__header">
                        <div class="title">
                            attributes
                        </div>
                        <!--                        <div class="button">-->
                        <!--                            <div class="label">-->
                        <!--                                Select All-->
                        <!--                            </div>-->
                        <!--                            <div @click="selectAllfeatures(!localUser.features.isSelectedAll)">-->
                        <!--                                <VCheckbox-->
                        <!--                                    :checked="localUser.features.isSelectedAll"-->
                        <!--                                />-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                    </div>
                    <div class="column__item__body">
                        <!--                        <div class="checkboxes">-->
                        <!--                            <template-->
                        <!--                                v-for="(item, itemIndex) in localUser.features.items"-->
                        <!--                            >-->
                        <!--                                <div-->
                        <!--                                    v-if="!item.isAttributeWithOptions"-->
                        <!--                                    :key="itemIndex"-->
                        <!--                                    class="checkbox"-->
                        <!--                                    :class="{'checkbox_with-options':item.isAttributeWithOptions}"-->
                        <!--                                >-->
                        <!--                                    <div-->
                        <!--                                        class="checkbox__row"-->
                        <!--                                        @click="selectAttribute(item)"-->
                        <!--                                    >-->
                        <!--                                        <VCheckbox-->
                        <!--                                            :checked="item.isActive"-->
                        <!--                                        />-->
                        <!--                                        <div class="checkbox__label">-->
                        <!--                                            {{ item.name }}-->
                        <!--                                        </div>-->
                        <!--                                    </div>-->
                        <!--                                    <div-->
                        <!--                                        class="checkbox__options"-->
                        <!--                                        v-if="item.isAttributeWithOptions && item.isActive"-->
                        <!--                                    >-->
                        <!--                                        <VRadioSwitcher-->
                        <!--                                            :options.sync="item.switcherOptions"-->
                        <!--                                            :type="'Object'"-->
                        <!--                                            :sync="false"-->
                        <!--                                            @updateOptions="changeSwitchOption(itemIndex,$event)"-->
                        <!--                                        ></VRadioSwitcher>-->
                        <!--                                        <VFilter-->
                        <!--                                            v-if="item.switcherOptions.Selected.isSelected"-->
                        <!--                                            :options="item.allOptions"-->
                        <!--                                            v-model="item.options"-->
                        <!--                                            show-property="name"-->
                        <!--                                            unique-property="name"-->
                        <!--                                            @closed="changeSwitchOption(itemIndex,'Selected')"-->
                        <!--                                        >-->
                        <!--                                            Choose {{ item.name }}-->
                        <!--                                        </VFilter>-->
                        <!--                                    </div>-->
                        <!--                                </div>-->
                        <!--                            </template>-->
                        <!--                        </div>-->
                        <div class="checkboxes checkboxes_with-options">
                            <template
                                    v-for="(item, itemIndex) in localUser.features.items"
                            >

                                <div
                                        v-if="item.isAttributeWithOptions"
                                        :key="itemIndex"
                                        class="checkbox_with-options"
                                >
                                    <div
                                            class="checkbox__row"
                                            @click="selectAttribute(item)"
                                    >
                                        <div class="checkbox__label">
                                            {{ item.name }}
                                        </div>
                                    </div>
                                    <div
                                            class="checkbox__options"
                                            v-if="item.isAttributeWithOptions"
                                    >
                                        <VRadioSwitcher
                                                :options.sync="item.switcherOptions"
                                                :type="'Object'"
                                                :sync="false"
                                                @updateOptions="changeSwitchOption(itemIndex,$event)"
                                        ></VRadioSwitcher>
                                        <VLabelCombobox
                                                :class="{invalid:!item.isValid}"
                                                v-if="item.switcherOptions.Selected.isSelected"
                                                :items.sync="item.allOptions"
                                                @change="featureOptionsChanged(itemIndex)"
                                        ></VLabelCombobox>
                                        <!--                                        <VRadioSwitcher-->
                                        <!--                                            :options.sync="item.switcherOptions"-->
                                        <!--                                            :type="'Object'"-->
                                        <!--                                            :sync="false"-->
                                        <!--                                            @updateOptions="changeSwitchOption(itemIndex,$event)"-->
                                        <!--                                        ></VRadioSwitcher>-->
                                        <!--                                        <VFilter-->
                                        <!--                                            v-if="item.switcherOptions.Selected.isSelected"-->
                                        <!--                                            :options="item.allOptions"-->
                                        <!--                                            v-model="item.options"-->
                                        <!--                                            show-property="name"-->
                                        <!--                                            unique-property="name"-->
                                        <!--                                            @closed="changeSwitchOption(itemIndex,'Selected')"-->
                                        <!--                                        >-->
                                        <!--                                            Choose {{ item.name }}-->
                                        <!--                                        </VFilter>-->
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="column__item column__item_dashboard-access">
                    <div class="column__item__header">
                        <div class="title">
                            dashboard access
                        </div>
                    </div>
                    <div class="column__item__body dashboard-access__body">
                        <div class="dashboard-access__label">
                            Block dashboards
                        </div>
                        <VToggle
                                :checked="!!localUser.block_dashboards"
                                :sync="true"
                                @change="toggleBlockDashboards"
                        />
                    </div>
                    <div class="dashboard-access__hint">
                        When enabled, the user sees the apps list and a Claude prompt instead of the dashboard.
                    </div>
                </div>
                <div
                        v-if="isEditMode"
                        class="user-page__buttons"
                >
                    <VButton
                            :type="'button'"
                            :theme="'light-blue'"
                            class="button button_delete"
                            @click="deleteUser"
                    >
                        Delete User
                    </VButton>
                    <VButton
                            :type="'button'"
                            :theme="'green'"
                            class="button button_apply"
                            @click="applyChanges"
                    >
                        Save
                    </VButton>
                </div>
            </div>
        </div>
        <div
                v-if="!isEditMode"
                class="user-page__footer"
        >
            <div class="item">
                <VButton
                        :type="'button'"
                        :theme="'green'"
                        class="button button_apply"
                        @click="applyChanges"
                >
                    Send Invitation
                </VButton>
            </div>

        </div>
    </div>
</template>

<script>
    import {
        validateEmail,
    } from '../../helpers/dataValidation';
    import VToggle from '@/components/VToggle';

    export default {
        name: 'User',
        components: {
            VToggle,
        },
        props: {
            user: {
                type: Object,
                required: true,
                default: () => ({}),
            },
            userIndex: {
                type: Number,
                required: true,
                default: 0,
            },
        },
        data() {
            return {
                validation: {
                    name: true,
                    email: true,
                    apps: true,
                    events: true,
                    features: true,
                },
                isEditMode: false,
                localUser: {},
                dates: {
                    start: '',
                    end: '',
                },
                minDate: new Date(2019, 0, 1),
                appSearchTerm: '',
            };
        },
        computed: {
            filteredApps() {
                return (this.localUser.apps?.items || []).filter((app) => {
                    if (this.appSearchTerm.length) {
                        return (app.title &&
                            app.title.trim().toLowerCase().includes(this.appSearchTerm.trim().toLowerCase())) ||
                            (app.bundle_id &&
                            app.bundle_id.trim().toLowerCase().includes(this.appSearchTerm.trim().toLowerCase()));
                    }
                    return true;
                });
            }
        },
        created() {
            window.scrollTo({
                top: 0,
                behavior: 'instant',
            });
            this.localUser = _.cloneDeep(this.user);
            if (this.user.filters.date) {
                this.dates = Object.assign(this.dates, this.user.filters.date);
            }
            ['events', 'features', 'apps'].forEach((property) => {
                this.localUser[property].isSelectedAll = this.localUser[property].items.every((item) => item.isActive);
            });
            this.isEditMode = !!this.localUser.email.length;
        },
        methods: {
            showTooltip(event, tooltipFunction, data) {
                this.$emit('showTooltip', event, tooltipFunction, data);
            },
            changeDate(value, property) {
                if (value) {
                    this.dates[property] = value;
                }
            },
            disabledStartDate(date) {
                return date < this.minDate;
            },
            disabledEndDate(date) {
                return date < this.minDate;
            },
            featureOptionsChanged(itemIndex) {
                if (!this.localUser.features.items[itemIndex].isValid &&
                    this.localUser.features.items[itemIndex].allOptions.length) {
                    this.localUser.features.items[itemIndex].isValid = true;
                }
            },
            returnButton() {
                this.$emit('changePage');
            },
            chooseApplication(item) {
                item.isActive = !item.isActive;
                this.localUser.apps.isSelectedAll = !this.localUser.apps.items.some((item) => item.isActive === false);
            },
            chooseEvent(event) {
                event.isActive = !event.isActive;
                this.localUser.events.isSelectedAll = !this.localUser.events.items.some((item) => item.isActive === false);
            },
            selectAttribute(attribute) {
                attribute.isActive = !attribute.isActive;
                this.localUser.features.isSelectedAll = !this.localUser.features.items.some((item) => item.isActive === false);
            },
            toggleBlockDashboards(value) {
                this.$set(this.localUser, 'block_dashboards', !!value);
            },
            selectAllEvents(state) {
                this.localUser.events.isSelectedAll = state;
                this.localUser.events.items.forEach((item) => {
                    item.isActive = state;
                });
            },
            selectAllapps(state) {
                this.localUser.apps.isSelectedAll = state;
                this.localUser.apps.items.forEach((item) => {
                    item.isActive = state;
                });
            },
            selectAllfeatures(state) {
                this.localUser.features.isSelectedAll = state;
                this.localUser.features.items.forEach((item) => {
                    item.isActive = state;
                    if (item.isAttributeWithOptions) {
                        item.options = [];
                        item.switcherOptions.All.isSelected = true;
                        item.switcherOptions.Selected.isSelected = false;
                    }
                });
            },
            deleteUser() {
                this.$emit('deleteUser', this.localUser, this.localUser.profilename);
            },
            applyChanges() {
                if (this.validateInfo()) {
                    const featuresWithAttributes = this.localUser.features.items.filter(({isAttributeWithOptions}) => isAttributeWithOptions);
                    if (featuresWithAttributes.length) {
                        const equal = {};
                        featuresWithAttributes.forEach((feature) => {
                            if (feature.switcherOptions.Selected.isSelected && feature.allOptions.length) {
                                equal[feature.name] = feature.allOptions;
                            }
                        });
                        this.localUser.filters.equal = equal;
                    }
                    const isEmptyObject = (obj) => {
                        return typeof obj === 'object' && Object.keys(obj).length === 0;
                    };

                    if (this.dates.start || this.dates.end) {
                        if (!this.dates.start || isEmptyObject(this.dates.start)) {
                            delete this.dates.start;
                        }
                        if (!this.dates.end || isEmptyObject(this.dates.end)) {
                            delete this.dates.end;
                        }
                        if (!this.dates || isEmptyObject(this.dates)) {
                            delete this.localUser.filters.date;
                        } else {
                            this.localUser.filters.date = this.dates;
                        }

                    } else {
                        delete this.localUser.filters.date;
                    }
                    if (!this.localUser.filters.func) {
                        delete this.localUser.filters.func;
                    }
                    this.$emit('applyChanges', _.cloneDeep(this.localUser), this.isEditMode);
                }
            },
            validateInfo() {
                const featuresWithAttributes = this.localUser.features.items.filter((item) =>
                    item.isAttributeWithOptions);
                let areFeaturesWithAttributesValid = true;
                featuresWithAttributes.forEach((feature) => {
                    if (feature.switcherOptions.All.isSelected) {
                        feature.isValid = true;
                    } else if (feature.switcherOptions.Selected.isSelected && feature.allOptions.length) {
                        feature.isValid = true;
                    } else {
                        feature.isValid = false;
                    }
                    if (areFeaturesWithAttributesValid && !feature.isValid) {
                        areFeaturesWithAttributesValid = false;
                    }
                });

                return [
                    areFeaturesWithAttributesValid,
                    this.validation.email = validateEmail(this.localUser.email),
                    this.validation.name = this.isEditMode ? true : !!this.localUser.profilename.trim().length,
                    this.validation.apps = this.localUser.apps.items.some((item) => item.isActive),
                    this.validation.events = this.localUser.events.items.some((item) => item.isActive),
                    this.validation.features = this.localUser.features.items.some((item) => item.isActive),
                ].every((validation) => validation === true);
            },
            changeSwitchOption(itemIndex, optionName) {
                const switcherOptions = this.localUser.features.items[itemIndex].switcherOptions;
                Object.entries(switcherOptions).forEach(([key]) => {
                    if (optionName !== key) {
                        switcherOptions[key].isSelected = false;
                    } else {
                        switcherOptions[key].isSelected = true;
                    }
                });

                if (optionName === 'All') {
                    this.localUser.features.items[itemIndex].options = [];
                }
            },
            funcRemove() {
                // this.localUser.filters.func.splice(funcIndex, 1);
                // if (!this.localUser.filters.func.length) {
                //     this.localUser.filters.func = null;
                // }
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
  @import "../../scss/base/colors";
  @import "../../scss/base/shadow";

  .create-users {
    color: $dark-blue-color;

    .page-sub-menu {
      display: flex;
      margin-bottom: 34px;

      ::v-deep {
        .VInput input {
          width: 337px;
          height: 37px;
        }
      }

      .input {
        margin-right: 20px;
      }
    }

    .page__dates {
      display: flex;
      align-items: center;
      margin-bottom: 34px;

      .date {
        display: flex;
        align-items: center;
        margin-right: 20px;

        &__label {
          margin-right: 10px;
        }
      }
    }

    .content {
      display: flex;

      .column {
        display: flex;
        flex-direction: column;
        width: fit-content;
        margin-right: 21px;
        height: fit-content;

        &:last-child {
          margin-right: 0;
        }

        &__item {
          @include dark-shadow;
          border-radius: 10px;
          padding: 15px 25px 20px 20px;
          width: fit-content;
          margin-bottom: 19px;
          height: fit-content;
          border: 1px solid #FFFFFF;

          &.invalid {
            border: 1px solid $negative-color;
          }

          &__header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 3px;

            .title {
              text-transform: capitalize;
              font-size: 16px;
              line-height: 20px;
              font-weight: 700;
            }

            .button {
              display: flex;
              align-items: center;

              .label {
                margin-right: 10px;
              }
            }
          }

          .tip-message {
            text-align: left;
            margin-bottom: 17px;
          }

          &__body {
            display: flex;
            flex-wrap: wrap;

            &-row {
              display: flex;
              flex-wrap: wrap;
            }

            .unit {
              width: 30px;
              height: 30px;
              background-size: cover;
              background-repeat: no-repeat;
              background-position: center;
              margin-right: 10px;
              margin-bottom: 10px;
              cursor: pointer;
              opacity: .15;
              border-radius: 4px;

              &.active {
                opacity: 1;
                width: 28px;
                height: 28px;
                border: 1px solid $primary-color;
              }
            }

            .checkboxes {
              display: flex;
              flex-wrap: wrap;
              width: 100%;

              .checkbox {
                display: flex;
                align-items: self-start;
                flex: 1;
                min-width: 23%;
                max-width: 25%;
                margin-bottom: 10px;
                flex-wrap: wrap;

                &__row {
                  display: flex;
                  cursor: pointer;
                  align-items: center;
                }

                &_with-options {
                  flex-direction: column;
                  display: flex;
                  width: 50%;
                  margin: 10px 0;

                  ::v-deep {
                    .VButton {
                      padding: 7px 10px;

                      &-select::after {
                        top: 3px;
                        right: 15px;
                      }

                      &-select::before {
                        top: 26px;
                      }
                    }

                    .VFilter-dropdown {
                      min-width: 142px;
                    }
                  }
                }

                &__label {
                  margin-left: 10px;
                }

                &__options {
                  margin-top: 15px;

                  ::v-deep {
                    .VRadioSwitcher {
                      margin-bottom: 15px;

                      .radio:first-child {
                        margin-right: 0;
                        margin-left: 0;
                      }
                    }
                  }
                }
              }

              &_with-options {
                display: flex;
                flex-wrap: wrap;

                ::v-deep {
                  .VLabelCombobox-items__item {
                    margin-top: 10px;

                    .VLabel {
                      font-weight: 200;
                    }
                  }
                }
              }
            }

            ::v-deep {
              .VLabel {
                margin-right: 10px;
                margin-bottom: 10px;
                display: flex;
                justify-content: center;
                padding: 4px 13px;

                &_remove {
                  padding: 6px 15px;
                }

                .VLabel-action {
                  display: none;
                }
              }
            }
          }

          &_apps {
            width: 304px;
            padding: 15px 25px 19px 20px;

            .column__item__header {
              margin-bottom: 8px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 8px;
              
              .title {
                flex-shrink: 0;
                min-width: fit-content;
              }
              
              .header-controls {
                display: flex;
                align-items: center;
                gap: 12px;
                flex: 1;
                
                .VSearch {
                  pointer-events: none;
                  flex: 1;
                  min-width: 100px;
                  height: 28px;
                  border: 1px solid $primary-color;
                  padding-left: 6px;
                  border-radius: 4px;
                  display: flex;
                  align-items: center;
                  
                  &-icon {
                    pointer-events: all;
                    width: 12px;
                    height: 12px;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE5cHgiIGhlaWdodD0iMThweCIgdmlld0JveD0iMCAwIDE5IDE4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4NCiAgICA8dGl0bGU+QTcyNTJFQUQtRTA4Qi00NjVELUI3QTEtMURBMUIyQTBCREU2QDEsNXg8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4NCiAgICA8ZyBpZD0iUGFnZS00IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9Ik1haW5fcGxhaW5fb3Blbl9ldmVudHMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MDAuMDAwMDAwLCAtMjU4LjAwMDAwMCkiIGZpbGw9IiMwMkRGQjAiIHN0cm9rZT0iIzYwODlFNyI+DQogICAgICAgICAgICA8ZyBpZD0idGFibGVzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4MC4wMDAwMDAsIDI0MC4wMDAwMDApIj4NCiAgICAgICAgICAgICAgICA8ZyBpZD0idGFibGVfMSI+DQogICAgICAgICAgICAgICAgICAgIDxnIGlkPSJ0YWJsZV9pbm5lcl9oZWFkZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAxNS4wMDAwMDApIj4NCiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJpY29uL3NlYXJjaCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTE3LjAwMDAwMCwgMC4wMDAwMDApIj4NCiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy4wODY4MTEsIDEzLjM1ODc3MSkgcm90YXRlKC00NS4wMDAwMDApIHRyYW5zbGF0ZSgtMTMuMDg2ODExLCAtMTMuMzU4NzcxKSB0cmFuc2xhdGUoNS4wODY4MTEsIDIuODU4NzcxKSIgaWQ9IkNvbWJpbmVkLVNoYXBlIj4NCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTkuODk5MDYzNjUsMTQuNTQyOTk4NyBMOS44OTkwNjM2NSwxOC44MjU5NTI2IEM5Ljg5OTA2MzY1LDE5LjY1NDM3OTcgOS4yMjc0OTA3NywyMC4zMjU5NTI2IDguMzk5MDYzNjUsMjAuMzI1OTUyNiBMOC4zNTM5NTA4NiwyMC4zMjU5NTI2IEM3LjUyNTUyMzc0LDIwLjMyNTk1MjYgNi44NTM5NTA4NiwxOS42NTQzNzk3IDYuODUzOTUwODYsMTguODI1OTUyNiBMNi44NTM5NTA4NiwxNC43MTAyNDk4IEMzLjQ2OTA1MjU0LDE0LjE3NTE1NDkgMC44ODMxNDEyNTksMTEuMjg0NTg0NSAwLjg4MzE0MTI1OSw3Ljc5ODk4OTg3IEMwLjg4MzE0MTI1OSwzLjkzMjk5NjYyIDQuMDY0Mjc1OTMsMC43OTg5ODk4NzMgNy45ODg0MDQ0MiwwLjc5ODk4OTg3MyBDMTEuOTEyNTMyOSwwLjc5ODk4OTg3MyAxNS4wOTM2Njc2LDMuOTMyOTk2NjIgMTUuMDkzNjY3Niw3Ljc5ODk4OTg3IEMxNS4wOTM2Njc2LDExLjAxMjg2MTYgMTIuODk1MjE1NywxMy43MjA4NjQ1IDkuODk5MDYzNjUsMTQuNTQyOTk4NyBaIE03Ljk4ODQwNDQyLDExLjc5ODk4OTkgQzEwLjIzMDc2MzYsMTEuNzk4OTg5OSAxMi4wNDg1NTQ4LDEwLjAwODEyODkgMTIuMDQ4NTU0OCw3Ljc5ODk4OTg3IEMxMi4wNDg1NTQ4LDUuNTg5ODUwODcgMTAuMjMwNzYzNiwzLjc5ODk4OTg3IDcuOTg4NDA0NDIsMy43OTg5ODk4NyBDNS43NDYwNDUyOCwzLjc5ODk4OTg3IDMuOTI4MjU0MDQsNS41ODk4NTA4NyAzLjkyODI1NDA0LDcuNzk4OTg5ODcgQzMuOTI4MjU0MDQsMTAuMDA4MTI4OSA1Ljc0NjA0NTI4LDExLjc5ODk4OTkgNy45ODg0MDQ0MiwxMS43OTg5ODk5IFoiPjwvcGF0aD4NCiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+DQogICAgICAgICAgICAgICAgICAgICAgICA8L2c+DQogICAgICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgICAgICA8L2c+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4=');
                  }
                  
                  ::v-deep .VInput {
                    pointer-events: all;
                    flex: 1;
                    
                    input {
                      font-family: Quicksand;
                      font-size: 12px;
                      border: none;
                      width: 100%;
                      border-radius: 4px;
                      padding-left: 5px;
                      background: transparent;
                      
                      &::placeholder {
                        font-style: italic;
                        font-weight: 400;
                        color: #999;
                      }
                    }
                  }
                }
                
                .button {
                  flex-shrink: 0;
                  min-width: fit-content;
                }
              }
            }

            .tip-message {
              margin-bottom: 22px;
            }
          }

          &_features {
            width: 590px;

            .column__item__header {
              margin-bottom: 15px;
            }
          }

          &_dashboard-access {
            width: 590px;

            .column__item__header {
              margin-bottom: 12px;
            }

            .dashboard-access {
              &__body {
                display: flex;
                align-items: center;
                gap: 14px;
              }

              &__label {
                font-weight: 600;
              }

              &__hint {
                margin-top: 10px;
                font-size: 12px;
                color: #3F3F40;
              }
            }
          }

          &_events {
            padding: 13px 25px 10px 20px;

            .column__item__header {
              padding-right: 10px;
            }

            padding-right: 10px;
            width: 320px;
          }
        }

        .user-page__buttons {
          display: flex;
          justify-content: flex-end;

          ::v-deep {
            .VButton {
              margin-left: 20px;
            }
          }
        }
      }
    }

    .user-page__footer {
      width: 1012px;
      display: flex;
      justify-content: flex-end;

      .item {
        margin-right: 5px;
        width: 171px;
        margin-top: -6px;
      }
    }
  }
</style>
